import React, { memo } from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { GHOST_VARIANT, ICON_ONLY, SIZE_44 } from '@yme/atoms/button';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { getPaginationLabel } from './helpers';
import { ButtonStyled, PaginationText } from './styled';
export const Pagination = memo(({ paginationData: { firstItem, lastItem, dealerListLength, maxPageIndex }, isRightToLeft, activePage, onPrevious, onNext, }) => {
    const { t } = useTranslation();
    const { isMobileView } = useWindowSize();
    const paginationLabel = getPaginationLabel({
        paginationTemplateLabel: t('common_preferredDealerDealerListPagination_text'),
        firstItem,
        lastItem,
        dealerListLength,
    });
    return (React.createElement(FlexWrapper, { alignItems: "center", gap: INDENT.xxs, justifyContent: isMobileView ? 'space-between' : 'flex-start', isFullWidth: isMobileView, isRightToLeft: isRightToLeft },
        React.createElement(ButtonStyled, { size: SIZE_44, buttonVariant: GHOST_VARIANT, hasIconButton: ICON_ONLY, iconRotate: isRightToLeft ? 0 : 180, iconComponent: ArrowForward, disabled: activePage === 1, onClick: onPrevious }),
        React.createElement(PaginationText, null, paginationLabel),
        React.createElement(ButtonStyled, { size: SIZE_44, buttonVariant: GHOST_VARIANT, hasIconButton: ICON_ONLY, iconRotate: isRightToLeft ? 180 : 0, iconComponent: ArrowForward, disabled: activePage === maxPageIndex, onClick: onNext })));
});
Pagination.displayName = 'PreferredDealerPagination';
